import React from 'react'
import dayjs from 'dayjs'

import Container from '../../atoms/Container'
import Row from '../../atoms/Row'
import Col from '../../atoms/Col'

import Heading from '../../atoms/Footer/Heading'
import Link from '../../atoms/Footer/Link'
import Logo from '../../atoms/Footer/Logo'
import Menu from '../../atoms/Footer/Menu'
import MenuItem from '../../atoms/Footer/MenuItem'
import Icon from '../../atoms/Icon'
import Background from '../../atoms/Footer/Background'

export default ({ width, legalName, icons, social, menu }) => (
  <Background width={width}>
    <Container>
      <Row>
        <Col>
          <Logo />
        </Col>
      </Row>
      <Row>
        <Col>
          <Heading as='h6'>
            &copy; {dayjs().format('YYYY')} Copyright {legalName}
          </Heading>
          <Menu inline>
            {icons.map((icon, i) => (
              <MenuItem icon key={i}>
                <Icon icon={icon} />
              </MenuItem>
            ))}
          </Menu>
          {social.length > 0 ? <Heading as='h6'>Connect with Us</Heading> : null}
          <Menu inline>
            {social.map(({ href, icon }, i) => (
              <MenuItem key={i} icon>
                <Link href={href}>
                  <Icon icon={icon} />
                </Link>
              </MenuItem>
            ))}
          </Menu>
        </Col>
        {menu.map(({ title, subMenu }, i) => (
          <Col key={i}>
            <Heading as='h6'>{title}</Heading>
            <Menu>
              {subMenu.map(({ href, title }, j) => (
                <MenuItem key={j}>
                  <Link href={href}>{title}</Link>
                </MenuItem>
              ))}
            </Menu>
          </Col>
        ))}
      </Row>
      <Row>
        <Col>
          <Heading as='h6'>
            Powered by <Link href='https://lineups.io'>lineups.io</Link>
          </Heading>
        </Col>
      </Row>
    </Container>
  </Background>
)
